export default __webpack_public_path__ + "static/media/crm-3.af832f91.jpg";